import { render, staticRenderFns } from "./ClientsManagementList.vue?vue&type=template&id=5b07491f"
import script from "./ClientsManagementList.vue?vue&type=script&lang=js"
export * from "./ClientsManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports